export default __webpack_public_path__ + "static/media/icon-arrow-right-vso.df46810b.svg";